"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var is_typedarray_1 = __importDefault(require("is-typedarray"));

var typedarray_to_buffer_1 = __importDefault(require("typedarray-to-buffer"));

var ENC_HEX = 'hex';
var ENC_UTF8 = 'utf8';
var ENC_BIN = 'binary';
var TYPE_BUFFER = 'buffer';
var TYPE_ARRAY = 'array';
var TYPE_TYPED_ARRAY = 'typed-array';
var TYPE_ARRAY_BUFFER = 'array-buffer';
var STRING_ZERO = '0';

function bufferToArray(buf) {
  return new Uint8Array(buf);
}

exports.bufferToArray = bufferToArray;

function bufferToHex(buf) {
  var prefixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hex = buf.toString(ENC_HEX);
  return prefixed ? addHexPrefix(hex) : hex;
}

exports.bufferToHex = bufferToHex;

function bufferToUtf8(buf) {
  return buf.toString(ENC_UTF8);
}

exports.bufferToUtf8 = bufferToUtf8;

function bufferToNumber(buf) {
  return buf.readUIntBE(0, buf.length);
}

exports.bufferToNumber = bufferToNumber;

function bufferToBinary(buf) {
  return arrayToBinary(bufferToArray(buf));
}

exports.bufferToBinary = bufferToBinary;

function arrayToBuffer(arr) {
  return typedarray_to_buffer_1.default(arr);
}

exports.arrayToBuffer = arrayToBuffer;

function arrayToHex(arr) {
  var prefixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return bufferToHex(arrayToBuffer(arr), prefixed);
}

exports.arrayToHex = arrayToHex;

function arrayToUtf8(arr) {
  return bufferToUtf8(arrayToBuffer(arr));
}

exports.arrayToUtf8 = arrayToUtf8;

function arrayToNumber(arr) {
  return bufferToNumber(arrayToBuffer(arr));
}

exports.arrayToNumber = arrayToNumber;

function arrayToBinary(arr) {
  return Array.from(arr).map(numberToBinary).join('');
}

exports.arrayToBinary = arrayToBinary;

function hexToBuffer(hex) {
  return Buffer.from(removeHexPrefix(hex), ENC_HEX);
}

exports.hexToBuffer = hexToBuffer;

function hexToArray(hex) {
  return bufferToArray(hexToBuffer(hex));
}

exports.hexToArray = hexToArray;

function hexToUtf8(hex) {
  return bufferToUtf8(hexToBuffer(hex));
}

exports.hexToUtf8 = hexToUtf8;

function hexToNumber(hex) {
  return arrayToNumber(hexToArray(hex));
}

exports.hexToNumber = hexToNumber;

function hexToBinary(hex) {
  return arrayToBinary(hexToArray(hex));
}

exports.hexToBinary = hexToBinary;

function utf8ToBuffer(utf8) {
  return Buffer.from(utf8, ENC_UTF8);
}

exports.utf8ToBuffer = utf8ToBuffer;

function utf8ToArray(utf8) {
  return bufferToArray(utf8ToBuffer(utf8));
}

exports.utf8ToArray = utf8ToArray;

function utf8ToHex(utf8) {
  var prefixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return bufferToHex(utf8ToBuffer(utf8), prefixed);
}

exports.utf8ToHex = utf8ToHex;

function utf8ToNumber(utf8) {
  var num = parseInt(utf8, 10);
  assert(isDefined(num), 'Number can only safely store up to 53 bits');
  return num;
}

exports.utf8ToNumber = utf8ToNumber;

function utf8ToBinary(utf8) {
  return arrayToBinary(utf8ToArray(utf8));
}

exports.utf8ToBinary = utf8ToBinary;

function numberToBuffer(num) {
  return binaryToBuffer(numberToBinary(num));
}

exports.numberToBuffer = numberToBuffer;

function numberToArray(num) {
  return binaryToArray(numberToBinary(num));
}

exports.numberToArray = numberToArray;

function numberToHex(num, prefixed) {
  return binaryToHex(numberToBinary(num), prefixed);
}

exports.numberToHex = numberToHex;

function numberToUtf8(num) {
  return "".concat(num);
}

exports.numberToUtf8 = numberToUtf8;

function numberToBinary(num) {
  var bin = (num >>> 0).toString(2);
  return sanitizeBytes(bin);
}

exports.numberToBinary = numberToBinary;

function binaryToBuffer(bin) {
  return arrayToBuffer(binaryToArray(bin));
}

exports.binaryToBuffer = binaryToBuffer;

function binaryToArray(bin) {
  return new Uint8Array(splitBytes(bin).map(function (x) {
    return parseInt(x, 2);
  }));
}

exports.binaryToArray = binaryToArray;

function binaryToHex(bin, prefixed) {
  return arrayToHex(binaryToArray(bin), prefixed);
}

exports.binaryToHex = binaryToHex;

function binaryToUtf8(bin) {
  return arrayToUtf8(binaryToArray(bin));
}

exports.binaryToUtf8 = binaryToUtf8;

function binaryToNumber(bin) {
  return arrayToNumber(binaryToArray(bin));
}

exports.binaryToNumber = binaryToNumber;

function isBinaryString(str) {
  if (typeof str !== 'string' || !new RegExp(/^[01]+$/).test(str)) {
    return false;
  }

  if (str.length % 8 !== 0) {
    return false;
  }

  return true;
}

exports.isBinaryString = isBinaryString;

function isHexString(str, length) {
  if (typeof str !== 'string' || !str.match(/^0x[0-9A-Fa-f]*$/)) {
    return false;
  }

  if (length && str.length !== 2 + 2 * length) {
    return false;
  }

  return true;
}

exports.isHexString = isHexString;

function isBuffer(val) {
  return Buffer.isBuffer(val);
}

exports.isBuffer = isBuffer;

function isTypedArray(val) {
  return is_typedarray_1.default.strict(val) && !isBuffer(val);
}

exports.isTypedArray = isTypedArray;

function isArrayBuffer(val) {
  return !isTypedArray(val) && !isBuffer(val) && typeof val.byteLength !== 'undefined';
}

exports.isArrayBuffer = isArrayBuffer;

function getType(val) {
  if (isBuffer(val)) {
    return TYPE_BUFFER;
  } else if (isTypedArray(val)) {
    return TYPE_TYPED_ARRAY;
  } else if (isArrayBuffer(val)) {
    return TYPE_ARRAY_BUFFER;
  } else if (Array.isArray(val)) {
    return TYPE_ARRAY;
  } else {
    return _typeof(val);
  }
}

exports.getType = getType;

function getEncoding(str) {
  if (isBinaryString(str)) {
    return ENC_BIN;
  }

  if (isHexString(str)) {
    return ENC_HEX;
  }

  return ENC_UTF8;
}

exports.getEncoding = getEncoding;

function concatBuffers() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var result = Buffer.concat(args);
  return result;
}

exports.concatBuffers = concatBuffers;

function concatArrays() {
  var result = [];

  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  args.forEach(function (arg) {
    return result = result.concat(Array.from(arg));
  });
  return new Uint8Array(_toConsumableArray(result));
}

exports.concatArrays = concatArrays;

function trimLeft(data, length) {
  var diff = data.length - length;

  if (diff > 0) {
    data = data.slice(diff);
  }

  return data;
}

exports.trimLeft = trimLeft;

function trimRight(data, length) {
  return data.slice(0, length);
}

exports.trimRight = trimRight;

function calcByteLength(length) {
  var byteSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var remainder = length % byteSize;
  return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}

exports.calcByteLength = calcByteLength;

function splitBytes(str) {
  var byteSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var bytes = sanitizeBytes(str).match(new RegExp(".{".concat(byteSize, "}"), 'gi'));
  return Array.from(bytes || []);
}

exports.splitBytes = splitBytes;

function swapBytes(str) {
  return splitBytes(str).map(reverseString).join('');
}

exports.swapBytes = swapBytes;

function swapHex(str) {
  return binaryToHex(swapBytes(hexToBinary(str)));
}

exports.swapHex = swapHex;

function sanitizeBytes(str) {
  var byteSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : STRING_ZERO;
  return padLeft(str, calcByteLength(str.length, byteSize), padding);
}

exports.sanitizeBytes = sanitizeBytes;

function padLeft(str, length) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : STRING_ZERO;
  return padString(str, length, true, padding);
}

exports.padLeft = padLeft;

function padRight(str, length) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : STRING_ZERO;
  return padString(str, length, false, padding);
}

exports.padRight = padRight;

function removeHexPrefix(hex) {
  return hex.replace(/^0x/, '');
}

exports.removeHexPrefix = removeHexPrefix;

function addHexPrefix(hex) {
  return hex.startsWith('0x') ? hex : "0x".concat(hex);
}

exports.addHexPrefix = addHexPrefix;

function sanitizeHex(hex) {
  hex = removeHexPrefix(hex);
  hex = sanitizeBytes(hex, 2);

  if (hex) {
    hex = addHexPrefix(hex);
  }

  return hex;
}

exports.sanitizeHex = sanitizeHex;

function removeHexLeadingZeros(hex) {
  var prefixed = hex.startsWith('0x');
  hex = removeHexPrefix(hex);
  hex = hex.startsWith(STRING_ZERO) ? hex.substring(1) : hex;
  return prefixed ? addHexPrefix(hex) : hex;
}

exports.removeHexLeadingZeros = removeHexLeadingZeros;

function isUndefined(value) {
  return typeof value === 'undefined';
}

function isDefined(value) {
  return !isUndefined(value);
}

function assert(assertion, errorMessage) {
  if (!assertion) {
    throw new Error(errorMessage);
  }
}

function reverseString(str) {
  return str.split('').reverse().join('');
}

function padString(str, length, left) {
  var padding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : STRING_ZERO;
  var diff = length - str.length;
  var result = str;

  if (diff > 0) {
    var pad = padding.repeat(diff);
    result = left ? pad + str : str + pad;
  }

  return result;
}